import styled from 'styled-components';
import { StyledFullscreenButton } from '../FullscreenButton/FullscreenButton.styled';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';

export const StyledExpandedScreenButton = styled(StyledFullscreenButton)`
  .expanded-screen-icon {
    transform: scaleY(0.8);
  }

  &.active {
    height: 24px;

    .expanded-screen-icon {
      transform: scale(0.95, 0.65);
    }
  }

  @media (max-width: ${MediaQueryBreakpoints.md}) {
    display: none;
  }
`;
